(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('custom-trworkorder-type-attribute', {
            parent: 'entity',
            url: '/custom-trworkorder-type-attribute?page&sort&search',
            data: {
                authorities: [ 'ENTITY_CONFIGURATION' ],
                pageTitle: 'trakeyeApp.customWorkOrderTypeAttribute.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custom-trworkorder-type-attribute/custom-trworkorder-type-attributes.html',
                    controller: 'CustomTrWorkOrderTypeAttributeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customTrWorkOrderTypeAttribute');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('custom-trworkorder-type-attribute-detail', {
            parent: 'custom-trworkorder-type-attribute',
            url: '/custom-trworkorder-type-attribute/{id}',
            data: {
                authorities: [ 'ENTITY_CONFIGURATION' ],
                pageTitle: 'trakeyeApp.customWorkOrderTypeAttribute.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custom-trworkorder-type-attribute/custom-trworkorder-type-attribute-detail.html',
                    controller: 'CustomTrWorkOrderTypeAttributeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customTrWorkOrderTypeAttribute');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'CustomTrWorkOrderTypeAttribute', function($stateParams, CustomTrWorkOrderTypeAttribute) {
                    return CustomTrWorkOrderTypeAttribute.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'custom-trworkorder-type-attribute',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        /*.state('custom-trworkorder-type-attribute-detail.edit', {
            parent: 'custom-trworkorder-type-attribute-detail',
            url: '/detail/edit',
            data: {
                authorities: [ 'ENTITY_CONFIGURATION' ]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-trworkorder-type-attribute/custom-trworkorder-type-attribute-dialog.html',
                    controller: 'CustomTrWorkOrderTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CustomTrWorkOrderTypeAttribute', function(CustomTrWorkOrderTypeAttribute) {
                            return CustomTrWorkOrderTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })*/
        /*.state('custom-trworkorder-type-attribute.new', {
            parent: 'custom-trworkorder-type-attribute',
            url: '/new',
            data: {
                authorities: [ 'ENTITY_CONFIGURATION' ]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-trworkorder-type-attribute/custom-trworkorder-type-attribute-dialog.html',
                    controller: 'CustomTrWorkOrderTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                description: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('custom-trworkorder-type-attribute', null, { reload: 'custom-trworkorder-type-attribute' });
                }, function() {
                    $state.go('custom-trworkorder-type-attribute');
                });
            }]
        })*/
        
        .state('custom-trworkorder-type-attribute.new', {
			parent : 'custom-trworkorder-type-attribute',
			url : '/new',
			data : {
				authorities : [ 'ENTITY_CONFIGURATION' ]
			},
			views : {
				'content@' : {
					templateUrl: 'app/entities/custom-trworkorder-type-attribute/custom-trworkorder-type-attribute-dialog.html',
                    controller: 'CustomTrWorkOrderTypeAttributeDialogController',
                    controllerAs: 'vm',
				}
			},
			resolve : {
				entity : function() {
					return {
						name : null,
						description : null,
						id : null
					};
				}
			}
		})
        /*.state('custom-trworkorder-type-attribute.edit', {
            parent: 'custom-trworkorder-type-attribute',
            url: '/{id}/edit',
            data: {
                authorities: [ 'ENTITY_CONFIGURATION' ]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-trworkorder-type-attribute/custom-trworkorder-type-attribute-dialog.html',
                    controller: 'CustomTrWorkOrderTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CustomTrWorkOrderTypeAttribute', function(CustomTrWorkOrderTypeAttribute) {
                            return CustomTrWorkOrderTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('custom-trworkorder-type-attribute', null, { reload: 'custom-trworkorder-type-attribute' });
                }, function() {
                    $state.go('^');
                });
            }]
        })*/
		
		.state('custom-trworkorder-type-attribute.edit', {
			parent : 'custom-trworkorder-type-attribute',
			url : '/{id}/edit',
			data : {
				authorities : [ 'ENTITY_CONFIGURATION' ],
				pageTitle : 'trakeyeApp.customWorkOrderTypeAttribute.home.title'
			},
			views : {
				'content@' : {
					templateUrl: 'app/entities/custom-trworkorder-type-attribute/custom-trworkorder-type-attribute-dialog.html',
                    controller: 'CustomTrWorkOrderTypeAttributeDialogController',
                    controllerAs: 'vm'
				}
			},
			resolve : {
				translatePartialLoader : [ '$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('customTrWorkOrderTypeAttribute');
					return $translate.refresh();
				} ],
				entity : [ '$stateParams', 'CustomTrWorkOrderTypeAttribute', function($stateParams, CustomTrWorkOrderTypeAttribute) {
					return CustomTrWorkOrderTypeAttribute.get({
						id : $stateParams.id
					}).$promise;
				} ],
				previousState : [ "$state", function($state) {
					var currentStateData = {
						name : $state.current.name || 'custom-trworkorder-type-attribute',
						params : $state.params,
						url : $state.href($state.current.name, $state.params)
					};
					return currentStateData;
				} ]
			}
		})
        .state('custom-trworkorder-type-attribute.delete', {
            parent: 'custom-trworkorder-type-attribute',
            url: '/{id}/delete',
            data: {
                authorities: [ 'ENTITY_CONFIGURATION' ],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-trworkorder-type-attribute/custom-trworkorder-type-attribute-delete-dialog.html',
                    controller: 'CustomTrWorkOrderTypeAttributeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CustomTrWorkOrderTypeAttribute', function(CustomTrWorkOrderTypeAttribute) {
                            return CustomTrWorkOrderTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('custom-trworkorder-type-attribute', null, { reload: 'custom-trworkorder-type-attribute' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();


/*(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('custom-trworkorder-type-attribute', {
            parent: 'entity',
            url: '/custom-trworkorder-type-attribute?page&sort&search',
            data: {
                authorities: [ 'ENTITY_CONFIGURATION' ],
                pageTitle: 'trakeyeApp.customTrWorkOrderTypeAttribute.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custom-trworkorder-type-attribute/custom-trworkorder-type-attributes.html',
                    controller: 'CustomTrWorkOrderTypeAttributeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customTrWorkOrderTypeAttribute');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('custom-trworkorder-type-attribute-detail', {
            parent: 'custom-trworkorder-type-attribute',
            url: '/custom-trworkorder-type-attribute/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'trakeyeApp.customTrWorkOrderTypeAttribute.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custom-trworkorder-type-attribute/custom-trworkorder-type-attribute-detail.html',
                    controller: 'CustomTrWorkOrderTypeAttributeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customTrWorkOrderTypeAttribute');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'CustomTrWorkOrderTypeAttribute', function($stateParams, CustomTrWorkOrderTypeAttribute) {
                    return CustomTrWorkOrderTypeAttribute.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'custom-trworkorder-type-attribute',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('custom-trworkorder-type-attribute-detail.edit', {
            parent: 'custom-trworkorder-type-attribute-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-trworkorder-type-attribute/custom-trworkorder-type-attribute-dialog.html',
                    controller: 'CustomTrWorkOrderTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CustomTrWorkOrderTypeAttribute', function(CustomTrWorkOrderTypeAttribute) {
                            return CustomTrWorkOrderTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('custom-trworkorder-type-attribute.new', {
            parent: 'custom-trworkorder-type-attribute',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-trworkorder-type-attribute/custom-trworkorder-type-attribute-dialog.html',
                    controller: 'CustomTrWorkOrderTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                description: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('custom-trworkorder-type-attribute', null, { reload: 'custom-trworkorder-type-attribute' });
                }, function() {
                    $state.go('custom-trworkorder-type-attribute');
                });
            }]
        })
        .state('custom-trworkorder-type-attribute.edit', {
            parent: 'custom-trworkorder-type-attribute',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-trworkorder-type-attribute/custom-trworkorder-type-attribute-dialog.html',
                    controller: 'CustomTrWorkOrderTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CustomTrWorkOrderTypeAttribute', function(CustomTrWorkOrderTypeAttribute) {
                            return CustomTrWorkOrderTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('custom-trworkorder-type-attribute', null, { reload: 'custom-trworkorder-type-attribute' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('custom-trworkorder-type-attribute.delete', {
            parent: 'custom-trworkorder-type-attribute',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-trworkorder-type-attribute/custom-trworkorder-type-attribute-delete-dialog.html',
                    controller: 'CustomTrWorkOrderTypeAttributeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CustomTrWorkOrderTypeAttribute', function(CustomTrWorkOrderTypeAttribute) {
                            return CustomTrWorkOrderTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('custom-trworkorder-type-attribute', null, { reload: 'custom-trworkorder-type-attribute' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();*/
